/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Template_Master_HintInputs */



/**
* | output |
* | --- |
* | "Upload your company's empty PowerPoint template and slides are filled into its own layouts on download." |
*
* @param {Presentation_Template_Master_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_master_hint = /** @type {((inputs?: Presentation_Template_Master_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Master_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Laden Sie die leere PowerPoint-Vorlage Ihres Unternehmens hoch – die Inhalte werden beim Download in deren eigene Layouts eingefügt.")
	return /** @type {LocalizedString} */ ("Upload your company's empty PowerPoint template and slides are filled into its own layouts on download.")
});